import { render, staticRenderFns } from "./NavBarRouter.vue?vue&type=template&id=64ec15af&scoped=true&"
import script from "./NavBarRouter.vue?vue&type=script&lang=ts&"
export * from "./NavBarRouter.vue?vue&type=script&lang=ts&"
import style0 from "./NavBarRouter.vue?vue&type=style&index=0&id=64ec15af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec15af",
  null
  
)

export default component.exports